import React from "react";
import { Dialog, Button, Typography, Box, Stack } from "@mui/material";
import GoogleLoginButton from "./GoogleLoginButton";

export default function AuthPromptDialog({ open, onClose, message }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Box sx={{ p: 2 }}>
        <Typography gutterBottom variant="h6">
          <b>Login or create an account to continue</b>
        </Typography>
        <Typography variant="body1" gutterBottom>
          {message} requires an account so your changes can be saved and synced.
        </Typography>
        <Typography variant="body1">
          It’s completely free, takes just 10 seconds, and all you need is a
          Google account...
        </Typography>
        <Typography></Typography>
        <Stack
          sx={{ mt: 2 }}
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={1}
          justifyContent={{ xs: "center", sm: "flex-end" }}
        >
          <Button onClick={onClose} variant="outlined">
            Not now
          </Button>
          <GoogleLoginButton />
        </Stack>
      </Box>
    </Dialog>
  );
}
